import React from 'react'

import { SiteContext } from 'context/site-context'

import { sortBy } from 'lodash'

import { useHistory } from 'react-router-dom'

import Carousel from 'components/atoms/Carousel'
import Categories from 'components/sections/Categories'
import GeicoBanner from 'components/atoms/GeicoBanner'
import ExternalLinks from 'components/atoms/ExternalLinks'
import Modal from 'components/atoms/Modal'
import Reviews from 'components/atoms/Reviews'
import ReviewSubmissionForm from 'components/atoms/ReviewSubmissionForm'

import {
  formatPhoneNumber,
  getAddress,
  getQS,
} from 'helpers'

import './index.scss'

const ProfileDetails = props => {
  const [ site, setSite ] = React.useContext(SiteContext)

  const [ state, setState ] = React.useState({
    images: [],
    isEmpty: false,
    isLoading: true,
    reviews: [],
  })

  const [ reviewModalShow, setReviewModalShow ] = React.useState(false)

  let history = useHistory()

  const cleanImages = (images = []) => {
    // Remove any image URLS that aren't https...
    images = images.filter( image => image.originalUrl.indexOf('https') > -1 )

    // If there's a "primary" image, set it as the frst.
    images = sortBy(images, ['primary']).reverse()

    return images
  }

  const cleanVideo = (video = []) => {
    if(!video) return null
    return video.length > 0 && video[0].url?.indexOf('https://') > -1 ? video[0].url : null
  }

  const fireTracking = url => {
    if(!url){
      return
    }
  
    const tracker = new Image()
    tracker.src = `${url}`
  }

  const hasAboutContent = () => {
    return state.ownerMessage?.aboutUs ||
          state.ownerMessage?.slogan ||
          state.ownershipTag ||
          state.offersRoundTheClockServices ||
          state.yearEstablished
  }

  const getHomeUrl = () => {
    const qs = getQS().trim().length > 0 ? `?${getQS()}` : ''
    return `${window.location.origin}/${site.path ? `${site.path}/${qs}` : qs}`
  }

  const getGraphQLEndpointQueryThingy = () => {
    return window.location.pathname.indexOf('/b/') > -1 ? 'findByIdExternalId' : 'searchByImportedListingIds'
  }

  const getGraphQLEndpointRequestPayloadThingy = () => {
    return window.location.pathname.indexOf('/b/') > -1 ? `externalListingId:{listingSource:"INSIDERPAGES",externalListingId:"${props.id}",affiliateIntegrationCode:"${new URLSearchParams(window.location.search).get('publisher') || 'insider_pages'}"}` : `request:{
      importedListingIds: ["${props.id}"],
      affiliateIntegrationCode: "${new URLSearchParams(window.location.search).get('publisher') || 'insider_pages'}"
    }`
  }

  // const renderAttribution = ( data = {} ) => {
  //   if(data.attribution_logo) {
  //     return <div className="provider-container">
  //       <span>Provided by</span>
  //       {data.attribution_url ? <a href={data.attribution_url}><img src={data.attribution_logo} /></a> : <img src={data.attribution_logo} />}
  //     </div>
  //   }

  //   if(data.attribution_text) {
  //     return <div className="provider-container">
  //       <span>Provided by</span>
  //       {data.attribution_url ? <a href={data.attribution_url}>{data.attribution_text}</a> : <span>{data.attribution_text}</span>}
  //     </div>
  //   }
  //   return null
  // }

  const renderBullets = ( bullets = [] ) => {
    if(!bullets) return

    bullets = bullets.filter( bullet => bullet.text && bullet.text.trim().length > 0 )
    return bullets.length > 0 ? <ul className="bullets-container">
      {bullets.map( bullet => <li key={bullet.text} dangerouslySetInnerHTML={{ __html: bullet.text }} /> )}
    </ul> : null
  }

  React.useEffect( () => {
    async function loadData() {
      try {
        const response = await fetch('https://apis.elocal.com/citygrid/graphql', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            query: `{
              ${getGraphQLEndpointQueryThingy()}(${getGraphQLEndpointRequestPayloadThingy()}){
                importedListing {
                  importedListing {
                    importedListingId
                    listingName
                    listingType
                    street1
                    city
                    stateOrProvince
                    postalCode
                    organicPhone
                    businessHours {
                      dayOfWeek
                      startTime
                      endTime
                    }
                    businessHoursAsText
                    websiteUrl
                    ownerMessage {
                      aboutUs
                      slogan
                      bullets {
                        text
                      }
                    }
                    ownershipTag
                    offersRoundTheClockServices
                    acceptedPaymentMethods
                    services {
                      id
                      name
                    }
                    servedGeographies {
                      id
                      name
                      type
                    }
                    yearEstablished
                    categories{
                      name
                    }
                  }
                  reviews {
                    reviewId
                    listingId
                    importedListingId
                    body
                    score
                    createdDate
                    creator
                    title
                    attributionUrl
                    attributionSource
                    hash
                  }
                  videos {
                    videoId
                    listingId
                    importedListingId
                    videoName
                    createdDate
                    description
                    duration
                    size
                    height
                    width
                    sourceUrl
                    sourceHash
                    fileExtension
                    creator
                    url
                  }
                  images {
                    imageId
                    primary
                    originalUrl
                  }
                }
                impression
              }
            }`
          })
        })
        .catch( e => {
          setState( prevState => ({
            ...prevState,
            isLoading: false,
            isEmpty: true,
          }))
        })

        const json = await response.json()

        if(json.errors){
          setState( prevState => ({
            ...prevState,
            isLoading: false,
            isEmpty: true,
          }))
        } else {
          const data = json?.data?.findByIdExternalId ? json?.data?.findByIdExternalId : json?.data?.searchByImportedListingIds[0]
          const result = (data.importedListing?.importedListing || {})

          fireTracking(data.impression)

          result.images = cleanImages(data.importedListing?.images || [])
          result.reviews = data.importedListing?.reviews || []
          result.video = cleanVideo(data.importedListing?.videos || [])

          setState( prevState => ({
            ...prevState,
            isLoading: false,
            ...result,
            isEmpty: !result.listingName,
          }))

          setSite({
            ...site,
            profile_listing: result,
          })
        }
      } catch(e){
        console.log(e)
        setState( prevState => ({
          ...prevState,
          isLoading: false,
          isEmpty: true,
        }))
      }
    }
    !site.isLoadingSiteData && loadData()

  }, [site.isLoadingSiteData])

  // React.useEffect( () => {
  //   // Retrieve any review content.
  //   async function loadReviews() {
  //     try {
  //       const url = process.env.REACT_APP_ENVIRONMENT === 'prod' ? 'https://api-indexer.elocal.com/viking-indexer/content/fetchReviews' : 'https://api-indexer-dev.elocal.com/viking-indexer/content/fetchReviews'
  //       const response = await fetch(url, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify({
  //           external_listing_id: props.id,
  //           listing_organisation: 'CITYGRID'
  //         })
  //       })

  //       if(response.status >= 200 && response.status <=299){
  //         const json = await response.json()
  //         setState( prevState => ({
  //           ...prevState,
  //           reviews: json,
  //         }))
  //       } else {
  //         console.debug(response.status, response.statusText)
  //       }
  //     } catch(e){
  //       console.debug('error', e)
  //     }
  //   }
  //   !site.isLoadingSiteData && loadReviews()
  // }, [site.isLoadingSiteData])

  return <div className="profile-details-container">
    <div className="container">
      {!state.isLoading && !state.isEmpty && <React.Fragment>
        <div className="business-details-wrapper">
          {state.images.length > 0 && <Carousel images={state.images} video={state.video} />}
          <div className="business-details">
            <h1 className="business-name">{state.listingName}</h1>
            <div className="address">{getAddress(state)} {state.postal_code || ''}</div>
            <ExternalLinks urls={state.urls} address={state} businessName={state.listingName} businessId={state.id} businessPhone={state.organicPhone} />
            {state.organicPhone && <div className="phone-trigger"><a href={`tel:${state.organicPhone}`}>{formatPhoneNumber(state.organicPhone)}</a></div>}
            {state.businessHoursAsText && <div className="business-hours"><label>Hours:</label> <span dangerouslySetInnerHTML={{ __html: state.businessHoursAsText}} /></div>}
            {state.ownerMessage?.slogan && <div className="teaser" dangerouslySetInnerHTML={{ __html: state.ownerMessage?.slogan}} />}
            {renderBullets(state.ownerMessage?.bullets)}
          </div>
        </div>

        {hasAboutContent() && <div className="panel-container customer-content">
          <h2>About {state.listingName}</h2>
          <div className="panel-details">
            {state.ownerMessage?.aboutUs && <div dangerouslySetInnerHTML={{ __html: state.ownerMessage?.aboutUs}} />}
            {state.ownerMessage?.slogan && <div dangerouslySetInnerHTML={{ __html: state.ownerMessage?.slogan}} />}
            {state.ownershipTag && <div dangerouslySetInnerHTML={{ __html: state.ownershipTag}} />}
            {state.offersRoundTheClockServices && <div>Offers Round The Clock Service</div>}
            {state.yearEstablished && <div>Established: {state.yearEstablished}</div>}
          </div>
        </div>}

        {state.categories?.length > 0 && <div className="panel-container">
          <h3>Additional Details</h3>
          <div className="panel-details">
            {state.categories.map( category => category.name ).join(', ')}
          </div>
        </div>}

        <div className="panel-container">
          <h3>Reviews</h3>
          <span className="review-submission-modal-trigger button-trigger mini" onClick={ () => setReviewModalShow(true) }>Submit a review</span>
          <Modal show={reviewModalShow} onClose={ () => setReviewModalShow(false) }>
            <ReviewSubmissionForm listing={state} />
          </Modal>
          {state.reviews.length > 0 && <Reviews reviews={state.reviews} />}
        </div>
      </React.Fragment>}

      {!state.isLoading && state.isEmpty && <div className="empty-container">
        <div>
          <h3>We're sorry, but the business information is not available at this time.</h3>
          {props.slug && <span className="button-trigger mini" onClick={ () => window.location.href = getHomeUrl() }>Try a different search</span>}
          {!props.slug && <span className="button-trigger mini" onClick={ () => history.goBack() }>Return to results page</span>}
        </div>
      </div>}

      {state.isLoading && <div className="loading-container">
        <h3>Loading...</h3>
      </div>}
    </div>
    <div className="container default-height">
      <GeicoBanner profileId={state.id} />
    </div>
    <Categories />
  </div>
}

export default ProfileDetails
